
import {observable} from "mobx";
import { PDFControlBaseOptions} from "InternalShared/PageBuilder/Controls/Core/PDFControlBase.Options";
import {ControlTypeEnum} from "PageBuilder/pagebuilder/Controls/NormalPDFControlFactory";


export class CustomFieldControlOptions extends PDFControlBaseOptions{
    Type:ControlTypeEnum;
    FieldId:string;
    @observable
    Label:string;
    @observable
    LabelPosition:LabelPositionEnum;
    SubType:string;


    protected LoadDefaultValues() {
        super.LoadDefaultValues();
        this.FieldId='';
        this.Label='';
        this.Type=ControlTypeEnum.CustomField;
        this.Styles.Width='180px';
        this.LabelPosition=LabelPositionEnum.Top;
        this.SubType='';
    }
}

export enum LabelPositionEnum{
    Top='Top',
    Bottom='Bottom',
    Lef='Left',
    Right='Right'
}